import { createReducer } from '@reduxjs/toolkit';
import {
  CREATE_DESIGN,
  CREATE_DESIGN_FAILED,
  UPDATE_ITEM_PRODUCT,
  UPDATE_ITEM_PRODUCT_FAILED,
  GET_DESIGN_BY_ITEM,
  GET_DESIGN_BY_ITEM_FAILED,
  ENABLE_SAVE,
  DISABLE_SAVE,
  SAVE_CONFIG_START,
  SAVE_CONFIG_SUCCESS,
  SAVE_CONFIG_FAILED,
  SAVE_ONLINE_DESIGN_SUCCESS,
  SAVE_ONLINE_DESIGN_FAILED,
  SEND_DESIGN_EMAIL_SUCCESS,
  SEND_DESIGN_EMAIL_FAILED,
  SET_IS_FROM_SAVE,
  BEGIN_DESIGN_IS_LOADING,
  END_DESIGN_IS_LOADING,
  setDesignDetails
} from '../actions/actionCreators';

const initialState = {
  currentDesign: {},
  currentItem: {},
  errors: { designApiError: false },
  isSaveEnabled: true,
  configurationSaved: false,
  designAssociated: false,
  emailSent: false,
  isLoading: false,
  isSaving: false,
  isFromSave: false,
};

const design = createReducer(initialState,
  (builder) => builder
    .addCase(BEGIN_DESIGN_IS_LOADING, (state) => ({ ...state, isLoading: true }))
    .addCase(END_DESIGN_IS_LOADING, (state) => ({ ...state, isLoading: false }))
    .addCase(setDesignDetails, (state, action) => ({ ...state, ...action.payload }))
    .addCase(GET_DESIGN_BY_ITEM, (state, action) => ({ ...state, ...action.payload })) // remove on clean up
    .addCase(CREATE_DESIGN, (state, action) => {
      const currentDesign = action.payload.design;
      const currentItem = action.payload.items[0];
      return { ...state, currentDesign, currentItem };
    })
    .addCase(UPDATE_ITEM_PRODUCT, (state, action) => ({ ...state, currentItem: action.payload.items[0] }))
    .addCase(ENABLE_SAVE, (state) => ({ ...state, isSaveEnabled: true }))
    .addCase(DISABLE_SAVE, (state) => ({ ...state, isSaveEnabled: false }))
    .addCase(SET_IS_FROM_SAVE, (state) => ({ ...state, isFromSave: true }))
    .addCase(SAVE_CONFIG_START, (state) => ({
      ...state,
      isFromSave: true,
      isLoading: true
    }))
    .addCase(SAVE_CONFIG_SUCCESS, (state) => ({
      ...state,
      isSaving: false,
      isLoading: false,
      isSaveEnabled: false,
      configurationSaved: true,
    }))
    .addCase(SAVE_CONFIG_FAILED, (state) => ({
      ...state,
      isSaving: false,
      isLoading: false,
      isSaveEnabled: true,
      configurationSaved: false,
    }))
    .addCase(SAVE_ONLINE_DESIGN_SUCCESS, (state) => ({
      ...state,
      designAssociated: true,
      isLoading: false,
    }))
    .addCase(SAVE_ONLINE_DESIGN_FAILED, (state) => ({
      ...state,
      designAssociated: false,
      isSaveEnabled: true,
      isSaving: false,
      isLoading: false,
    }))
    .addCase(SEND_DESIGN_EMAIL_SUCCESS, (state) => ({
      ...state,
      emailSent: true,
      isSaving: false,
    }))
    .addCase(SEND_DESIGN_EMAIL_FAILED, (state) => ({
      ...state,
      emailSent: false,
      isSaveEnabled: true,
      isSaving: false,
    }))
    .addMatcher(
      (action) => [CREATE_DESIGN_FAILED, UPDATE_ITEM_PRODUCT_FAILED, GET_DESIGN_BY_ITEM_FAILED].includes(action.type),
      (state, action) => ({
        ...state,
        isLoading: false,
        isSaving: false,
        errors: {
          designApiError: true,
          message: action.payload ? action.payload.message : '',
          messageDetail: action.payload ? action.payload.messageDetail : '',
        }
      }))
);

export default design;